import { parseItemDate } from './mapResponseToNotifications'

export default function(notifications) {
  return notifications
    ? notifications.map(item => ({
        actionLabel: item.actionLabel,
        bookingReservationId: item.bookingReservationId,
        bookingReservationLocalId: item.bookingReservationLocalId,
        data: item.data,
        email: item.email,
        fromDate: item.fromDate,
        iCalendarReservationId: item.iCalendarReservationId,
        id: item.id,
        message: item.message,
        person: item.person,
        phone: item.phone,
        readAt: parseItemDate(item.read_at),
        reservationId: item.reservationId,
        seenAt: parseItemDate(item.seen_at),
        subtitle: item.subtitle,
        title: item.title,
        toDate: item.toDate,
        type: item.type,
      }))
    : []
}
